import {
  AspectRatio,
  Box,
  DarkMode,
  Flex,
  HStack,
  Image,
  Text,
} from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedDate } from "react-intl";
import { Href } from "../../Href";
import { Icon } from "../../Icon";
import { SocialsCardTags } from "./Tags";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/social/Post").Post} socialPost
 */
/**
 * @param {Props} props
 */
export function SocialsCard(props) {
  const { socialPost } = props;

  // TODO: Add the publication link
  const publication = socialPost?.publications?.[0];

  return (
    <Box
      position="relative"
      backgroundColor="brandPrimary.50"
      w={{ base: "300px", md: "full" }}
      borderRadius="4px"
      borderWidth="1px"
      role="group"
      overflow="hidden">
      <Href href={publication?.permalink_url} target="_blank">
        <>
          <Box position="relative" overflow="hidden">
            <Box borderBottomWidth="0" borderTopRadius="4px">
              <AspectRatio ratio={277 / 156}>
                <Image
                  src={
                    socialPost.pictures?.[0]?.url ||
                    generateFrontPath({
                      id: "@front.internal-assets",
                      parameters: { filePath: "placeholder.svg" },
                      includeBasePath: true,
                    })
                  }
                  loading="lazy"
                  objectFit="cover"
                  _groupHover={{
                    transform: "scale(1.1)",
                  }}
                  transition="all 0.25s ease"
                  alt=""
                />
              </AspectRatio>
            </Box>

            {publication?.published_at && (
              <DarkMode>
                <Box position="absolute" top="0" left="0" p="8px">
                  <Box
                    backgroundColor="brandPrimary.700"
                    borderRadius="4px"
                    opacity={0.9}
                    py="3px"
                    px="4px">
                    <Text variant="menu-dropdown" fontSize=".875rem">
                      <FormattedDate
                        value={publication.published_at}
                        day="numeric"
                        month="long"
                        year="numeric"
                      />
                    </Text>
                  </Box>
                </Box>
              </DarkMode>
            )}
          </Box>

          <Box
            p="1rem"
            borderLeftWidth="1px"
            borderLeftColor="brandPrimary.500"
            _groupHover={{
              borderLeftWidth: "2px",
            }}>
            <Text noOfLines={2} h="2.5rem">
              {socialPost.content}
            </Text>

            <Flex
              mt="2rem"
              justify="space-between"
              alignItems="center"
              wrap="wrap">
              <HStack>
                <SocialsCardTags
                  number={publication?.nb_likes || 0}
                  icon="ms_favorite"
                />

                <SocialsCardTags
                  number={publication?.nb_shares || 0}
                  icon="ms_share"
                />

                <SocialsCardTags
                  number={publication?.nb_comments || 0}
                  icon="ms_comment"
                />
              </HStack>

              <Icon
                icon={`sf_${publication?.page?.network}`}
                color="gray.600"
                size=".75rem"
              />
            </Flex>
          </Box>
        </>
      </Href>
    </Box>
  );
}
